<template>
  <div class="credit-trend-wrapper">
    <el-card :bordered="false">
      <span>Date Range:</span>
      <el-date-picker
        type="daterange"
        range-separator="-"
        style="margin: 0 20px 0 10px"
        v-model="date"
      />
      <customize-button
        type="primary"
        @click="initTable"
        style="margin-right: 20px"
      >
        Search
      </customize-button>
    </el-card>
    <el-card :bordered="false" style="margin-top: 24px">
      <div class="chart">
        <v-chart :options="chartOptions" />
      </div>
      <div class="details">
        <div class="left">Maximum Value</div>
        <div class="right">
          <el-row v-if="maxValues">
            <el-col :span="12">
              <span class="title">Credit Line :</span>
              {{ maxValues.maxValid.time }},
              {{ this.$utils.formatAmount(maxValues.maxValid.amount) }}
            </el-col>
            <el-col :span="12">
              <span class="title">Soft Collateral :</span>
              {{ maxValues.maxSoftCollateral.time }},
              {{ this.$utils.formatAmount(maxValues.maxSoftCollateral.amount) }}
            </el-col>
            <el-col :span="12">
              <span class="title">Hard Collateral :</span>
              {{ maxValues.maxHardCollateral.time }},
              {{ this.$utils.formatAmount(maxValues.maxHardCollateral.amount) }}
            </el-col>
            <el-col :span="12">
              <span class="title">Insurance :</span>
              {{ maxValues.maxTotalCollateral.time }},
              {{
                this.$utils.formatAmount(maxValues.maxTotalCollateral.amount)
              }}
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="table-wrapper">
        <table-view
          ref="tableList"
          :tableModel="tableModel"
          :tableData="tableData"
          :pages="pages"
          :pageSize="5"
          :isTableLoading="isTableLoading"
          @pageChange="handlePageChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { getMaxValues, getTableData } from './api'
import dayjs from 'dayjs'

export default {
  data() {
    const tableModel = [
      {
        label: 'Date',
        prop: 'time',
      },
      {
        label: 'Credit Line',
        prop: 'validAmount',
      },
      {
        label: 'Soft Collateral',
        prop: 'softCollateralAmount',
      },
      {
        label: 'Hard Collateral',
        prop: 'hardCollateralAmount',
      },
      {
        label: 'Insurance',
        prop: 'totalCollateralAmount',
      },
    ]
    return {
      maxValues: null,
      tableModel,
      tableData: [],
      pages: {},
      form: {},
      isTableLoading: true,
      companyId: this.$route.params.customerId,
      date: [],
      chartOptions: {
        // x 轴
        xAxis: {
          type: 'category',
          // 默认是 true x 轴两侧会有一些距离，
          boundaryGap: false,
          data: [],
        },
        // y 轴
        yAxis: {
          type: 'value',
        },
        // 系列对应图表
        series: [
          {
            data: [],
            type: 'line',
            name: 'Credit Line',
          },
          {
            data: [],
            type: 'line',
            name: 'Soft Collateral',
          },
          {
            data: [],
            type: 'line',
            name: 'Hard Collateral',
          },
          {
            data: [],
            type: 'line',
            name: 'Insurance',
          },
        ],
        tooltip: {
          trigger: 'axis',
          name: 'totalCollateralAmount',
        },
      },
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const date = dayjs().format('YYYY-MM-DD')
      const startDate = dayjs().subtract(1, 'year').format('YYYY-MM-DD')
      this.date = [startDate, date]
      this.initTable()
    },
    async _getMaxValues() {
      try {
        const submitData = {
          companyId: this.companyId,
          endTime: '',
          startTime: '',
        }
        if (this.date && this.date.length) {
          submitData.startTime = dayjs(this.date[0]).format('YYYY-MM-DD')
          submitData.endTime = dayjs(this.date[1]).format('YYYY-MM-DD')
        }
        this.maxValues = await getMaxValues(submitData)
        this.chartOptions.xAxis.data = this.maxValues.trend.map(
          item => item.time,
        )
        this.chartOptions.series[0].data = this.maxValues.trend.map(
          item => item.validAmount,
        )
        this.chartOptions.series[1].data = this.maxValues.trend.map(
          item => item.softCollateralAmount,
        )
        this.chartOptions.series[2].data = this.maxValues.trend.map(
          item => item.hardCollateralAmount,
        )
        this.chartOptions.series[3].data = this.maxValues.trend.map(
          item => item.totalCollateralAmount,
        )
      } catch (err) {
        console.error(err)
      }
    },
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableData({ ...params, companyId: this.companyId })
      this._getMaxValues()
    },
    async _getTableData(params) {
      this.isTableLoading = true
      try {
        const submitData = { ...params, endTime: '', startTime: '' }
        if (this.date && this.date.length) {
          submitData.startTime = dayjs(this.date[0]).format('YYYY-MM-DD')
          submitData.endTime = dayjs(this.date[1]).format('YYYY-MM-DD')
        }
        const { data, page } = await getTableData(submitData)
        this.tableData = data
        this.tableData.map(item => {
          item.validAmount = this.$utils.formatAmount(item.validAmount)
          item.softCollateralAmount = this.$utils.formatAmount(
            item.softCollateralAmount,
          )
          item.hardCollateralAmount = this.$utils.formatAmount(
            item.hardCollateralAmount,
          )
          item.totalCollateralAmount = this.$utils.formatAmount(
            item.totalCollateralAmount,
          )
        })
        this.pages = page
      } catch (err) {
        console.error(err)
      }
      this.isTableLoading = false
    },
    handlePageChange(params) {
      this._getTableData({ ...params, companyId: this.companyId })
    },
  },
}
</script>

<style scoped lang="scss">
.credit-trend-wrapper {
  .details {
    display: flex;
    border: 1px solid #e6e9f4;

    .left {
      width: 200px;
      height: 100px;
      background-color: #f5f5fa;
      text-align: center;
      line-height: 100px;
      font-size: 14px;
      color: #3a3f63;
    }

    .right {
      width: calc(100% - 210px);
      text-align: left;
      font-size: 14px;
      color: #3a3f63;
      padding: 19px 10px 0 19px;
      line-height: 30px;

      .title {
        font-size: 14px;
        color: #000000;
      }
    }
  }

  .table-wrapper {
    :deep(.card) {
      padding: 0;
    }
  }
  .chart {
    height: 400px;

    .echarts {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
